

























































import { Component } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';
import { mixins } from 'vue-class-component';
import {
  CreateGripBarrierBase,
  UpdateGripBarrierBase,
  CreateGripBarrierPayload,
  GetBarriersPayload,
  GripBarrier,
  UpdateGripBarrierPayload,
} from '../../../store/types/grip.types';
import BarrierModal from './BarrierModal.vue';
import { ApiState, Pagination } from '../../../store/types/general.types';
import BaseLoading from '../../../components/base/BaseLoading.vue';
import BarrierList from './BarrierList.vue';
import BasePaginatorHoc from '../../../components/base/BasePaginatorHoc.vue';
import GripSettingsModalManagerMixin from '@/views/Grip/components/grip-settings-modal-manager.mixin';

@Component({
  components: { BaseLoading, BasePaginatorHoc, BarrierList, BarrierModal },
})
export default class BarrierSettings extends mixins(
  GripSettingsModalManagerMixin,
) {
  public entityName: string = 'Barrier';
  public entityIdKey: string = 'barrierId';

  @Action('projects/getGripBarriers')
  public getGripBarriers!: (payload: {
    projectId: number;
    params: GetBarriersPayload;
  }) => void;

  @State((state) => state.projects.gripBarriers)
  public gripBarriers!: Pagination<GripBarrier>;

  @State((state) => state.projects.apiState.getGripBarriers)
  public getGripBarriersApiState!: ApiState;

  @Action('projects/createGripBarrier')
  public createGripBarrier!: (payload: CreateGripBarrierPayload) => void;

  @State((state) => state.projects.apiState.createGripBarrier)
  public createGripBarrierApiState!: ApiState;

  @Action('projects/updateGripBarrier')
  public updateGripBarrier!: (payload: UpdateGripBarrierPayload) => void;

  @State((state) => state.projects.apiState.updateGripBarrier)
  public updateGripBarrierApiState!: ApiState;

  @Action('projects/deleteGripBarrier')
  public deleteGripBarrier!: (payload: {
    projectId: number;
    barrierId: number;
  }) => void;

  @State((state) => state.projects.apiState.deleteGripBarrier)
  public deleteGripBarrierApiState!: ApiState;

  public getAction = this.getGripBarriers;
  public deleteAction = this.deleteGripBarrier;

  get getApiState(): ApiState {
    return this.getGripBarriersApiState;
  }
  get createApiState(): ApiState {
    return this.createGripBarrierApiState;
  }
  get updateApiState(): ApiState {
    return this.updateGripBarrierApiState;
  }
  get deleteApiState(): ApiState {
    return this.deleteGripBarrierApiState;
  }

  get BarrierList() {
    return BarrierList;
  }

  get getGripBarrierList(): GripBarrier[] {
    return this.gripBarriers.items || [];
  }

  // NEW: Added a dedicated computed property for totalCount
  get totalCount(): number {
    return this.gripBarriers.totalItems || 0;
  }

  /**
   * Handles the creation of a new barrier
   * @param {CreateGripBarrierBase} gripBarrier - Data from the modal form.
   */
  public handleBarrierCreate(gripBarrier: CreateGripBarrierBase): void {
    this.createGripBarrier({ ...gripBarrier, projectId: this.projectId });
  }

  /**
   * Handles the update of a barrier.
   * Triggered by the update event from BarrierModal component.
   * @param {UpdateGripBarrierBase & { id: number }} gripBarrierUpdateData - Data from the modal form.
   */
  public handleBarrierUpdate(
    gripBarrierUpdateData: UpdateGripBarrierBase & { id: number },
  ): void {
    if (
      this.editingEntityId !== null &&
      this.editingEntityId === gripBarrierUpdateData.id
    ) {
      const { id, ...changesToApply } = gripBarrierUpdateData;
      if (Object.keys(changesToApply).length > 0) {
        const payload: UpdateGripBarrierPayload = {
          ...gripBarrierUpdateData,
          id: this.editingEntityId,
          projectId: this.projectId,
        };
        this.updateGripBarrier(payload);
      } else {
        this.closeModal();
      }
    } else {
      this.closeModal();
    }
  }
}
